import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'
import router from '@/router'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {
    axios.interceptors.response.use(
      function(response) {
        return response
      },
      function(error) {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {

        if (
          response &&
          response.status === 401 &&
          !config.url.includes('auth')
        ) {
          if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true
            store
              .dispatch('auth/fetchAccessToken')
              .then(access_token => {
                isAlreadyFetchingAccessToken = false
                onAccessTokenFetched(access_token)
              })
              .catch(error => {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('userInfo')
                router.push('/login').catch(() => {})
              })
          }

          const retryOriginalRequest = new Promise(resolve => {
            addSubscriber(access_token => {
              originalRequest.headers.Authorization = `Bearer ${access_token}`
              resolve(axios(originalRequest))
            })
          })
          return retryOriginalRequest
        }
        return Promise.reject(error)
      },
    )
  },
  login(email, pwd, captcha, twofa, cfcaptcha) {
    return axios.post('auth/login', {
      email,
      password: pwd,
      captcha: captcha,
      twofa,
      cfcaptcha: cfcaptcha,
    })
  },
  loginOAuth(email, token, sub, type) {
    return axios.post('auth/login-oauth', {
      email, token, sub, type
    })
  },
  registerUser(firstname, lastname, email, phone, password, captcha, cfcaptcha) {
    return axios.post('auth/register', {
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      password: password,
      passwordconfirm: password,
      captcha: captcha,
      cfcaptcha: cfcaptcha,
    })
  },
  refreshToken() {
    return axios.post('auth/refresh-token', {
      refresh_token: localStorage.getItem('refreshToken'),
    })
  },

  updateUserPlan(plan_id) {
    return axios.patch(`/billing/subscription`, {
      plan_id: plan_id,
    })
  },

  updateUserinfo(first, last, phone) {
    return axios.post(`/user/updateGeneralInfo`, {
      firstname: first,
      lastname: last,
      phone: phone,
    })
  },
  enableTwoFactorAuth(code) {
    return axios.post(`/auth/2fa/enable`, code)
  },
  disableTwoFactorAuth(code) {
    return axios.post(`/auth/2fa/disable`, code)
  },
  getUserSummary() {
    return axios.get(`user/summary`)
  },
}
